import { useState, useEffect } from 'react';
import db, { auth } from '../Backend/firebase/firebase';
import { useDispatch } from 'react-redux';
import { loginSave } from '../DataStore/Slices/userSlice';
import server from '../Backend/axios';

function CheckUserProvider() {
    const dispatch = useDispatch();
    const [userData, setUserData] = useState(null);
    const [firebaseUserData, setFirebaseUserData] = useState(null);

    useEffect(async () => {
        const unsubscribe = auth.onAuthStateChanged(async (firebaseUser) => {
            if (firebaseUser != null) {
                const rolessRef = db.collection("Users").doc(firebaseUser.uid);
                const doc = await rolessRef.get();
                if (!doc.exists) {
                    console.log('No such document!');
                    setFirebaseUserData(firebaseUser);
                    setUserData({
                        name: '',
                        email: '',
                        uid: '',
                        userRole: '',
                        provider: firebaseUser.providerData[0].providerId
                    })
                    dispatch(loginSave({
                        user: userData
                    }));
                }
                else {
                    var roleData = doc.data();
                    setUserData({
                        name: roleData?.name,
                        email: roleData?.email,
                        uid: roleData?.uid,
                        userRole: roleData?.userRole,
                        provider: firebaseUser.providerData[0].providerId,
                        nameTitle: roleData?.nameTitle ? roleData?.nameTitle : '',
                        phoneNumber: roleData?.phoneNumber,
                        storeName: roleData?.storeName,
                        businessType: roleData?.businessType,
                        storeAddress: roleData?.storeAddress,
                        storeCity: roleData?.storeCity,
                        storeWebsite: roleData?.storeWebsite,
                        zipcode: roleData?.zipcode,
                        gstNo: roleData?.gstNo,
                        drugLicense: roleData?.drugLicense,
                        homeDelivery: roleData?.homeDelivery,
                        areaCovers: roleData?.areaCovers,
                        remarks: roleData?.remarks,
                        country: roleData?.country,
                        isPlanActivated: true,
                    })
                    dispatch(loginSave({
                        user: userData
                    }));
                }
            }
            else {
                setUserData(null);
                setFirebaseUserData(null);
            }
        })

        return () => unsubscribe();
    }, []);


    return { userData, firebaseUserData };
}

export default CheckUserProvider
